import { IBaseRequest } from '@r1-frontend/do-request/core/types';

export class DoRequest<I extends RequestInit> {
    constructor(
        private readonly baseRequest: IBaseRequest<I>,
    ) {}

    public async abonDiag<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_ABON_DIAG,
        }, request);
    }

    public async apiAuth<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_AUTH,
        }, request);
    }

    public async apiDelivery<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_DELIVERY,
        }, request);
    }

    public async apiContent<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_CONTENT,
            innerUrl: process.env.NEXT_PUBLIC_HOST_API_CONTENT_INNER,
        }, request);
    }

    public async apiContentStatic<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_CONTENT_STATIC,
        }, request);
    }

    public async apiEsign<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_ESIGN,
        }, request);
    }

    public async apiEPG<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_EPG,
        }, request);
    }

    public async apiGames<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_GAMES,
        }, request);
    }

    public async apiLoyalty<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_LOYALTY,
        }, request);
    }

    public async apiPay<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_PAY,
        }, request);
    }

    public async apiProfile<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_PROFILE,
        }, request);
    }

    public async apiRequest<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_REQUEST,
        }, request);
    }

    public async apiSeasonTicket<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_SEASON_TICKET,
        }, request);
    }

    public async apiTariffs<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_TARIFFS,
            innerUrl: process.env.NEXT_PUBLIC_HOST_API_TARIFFS_INNER,
        }, request);
    }

    public async apiVas<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_API_VAS,
        }, request);
    }

    public async apiWidgets<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_WIDGETS,
        }, request);
    }

    public async b2cDomru<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_B2C_DOMRU,
        }, request);
    }

    public async coreProfile<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_CORE_PROFILE,
        }, request);
    }

    public async coreRequests<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_CORE_REQUESTS,
        }, request);
    }

    public async coreCustomerDiagnostic<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_CORE_CUSTOMER_DIAGNOSTIC,
        }, request);
    }

    public async fullBuy<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_FULL_BUY,
        }, request);
    }

    public async gamersBase<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_GAMERS_BASE,
        }, request);
    }

    public async genesysProxy<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_GENESYS_PROXY,
        }, request);
    }

    public async multiscreen<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_MULTISCREEN,
        }, request);
    }

    public async payments<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_PAYMENTS,
        }, request);
    }

    public async phoneValidator<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_PHONE_VALIDATOR,
        }, request);
    }

    public async ppdService<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_PPD,
        }, request);
    }

    public async r1PlatformGateway<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_R1_PLATFORM_GATEWAY,
        }, request);
    }

    public async specOffer<T>(request: I) {
        return this.baseRequest.doRequest<T>({
            url: process.env.NEXT_PUBLIC_HOST_SPEC_OFFER,
        }, request);
    }
}
